import { fetch } from '@/utils/fetch'
import { DataListWrapper } from 'loca-boot-core'
import { FilterItem } from './filter.model'

/**
 * 获取资源筛选过滤器
 * https://apidoc.nioint.com/project/10079/interface/api/1108293
 * @param types 按顺序传入需要的类型，用逗号分隔，不传则返回全部类型
 * @returns
 */
export function getFilterData(types?: string) {
  return fetch.get('charge-map/v2/filter', {
    params: { types },
    wrapper: new DataListWrapper({ itemType: FilterItem }),
  })
}
